<template>
    <el-row>
        <el-col :span="8" class="logo" :class="collapsed?'logo-collapse-width':'logo-width'">
          <i><img src="static/ebus.png" alt=""/></i>
        </el-col>
        <el-col :span="8" class="web-name">
          <span>e巴士商业化运营平台</span>
        </el-col>
        <el-col :span="8" class="userinfo">
          <el-dropdown>
            <span class="el-dropdown-link">{{sysUserName}}</span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item divided @click.native="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-col>
    </el-row>
</template>
<style lang="less" scoped>
  .logo{
    background: #323b52;
    display: inline-block;
    width: 160px;
    margin-left: -21px;
    text-align: center;
    float: left;
    color: #fff;
    letter-spacing: 2px;
    font-size: 24px;
    i{
      display: inline-block;
      width: 78px;
      height: 26px;
      position:relative;
      top:17px;
      img{
        vertical-align: top;
      }
    }
  }
  .web-name{
    height: 60px;
    padding-left: 20px;
    color: #339C94;
    text-align:left;
    span{
      display: inline-block;
      height: 60px;
    }
  }
</style>
<script>
  export default{
      data(){
        return {
          sysName:'',
          sysUserName:'',
          collapsed:false
        }
      },
      methods:{
        //退出登录
        logout: function () {
          var _this = this;
          this.$confirm('确认退出吗?', '提示', {
            //type: 'warning'
          }).then(() => {
            sessionStorage.removeItem('token');
            _this.$router.push('/login');
          }).catch(() => {
          });
        }
      },
      mounted() {
        this.sysUserName=JSON.parse(sessionStorage.getItem('userInfo')).name;
        this.sysName='众行网'
      }
  }
</script>



// WEBPACK FOOTER //
// src/components/header.vue


// WEBPACK FOOTER //
// src/components/header.vue